import React from "react";
import { connect } from "react-redux";
import { SocialIcons } from "../../molecules/social-icons";
import get from "lodash/get";
import PT from "prop-types";
import "./footer.m.css";

function FooterBase(props) {
  return (
    <footer styleName="footer">
      <div className="container">
        <div styleName="container">
          <ul styleName="menu-items">
            {props.menu.map((item, index) => {
              return (
                <li key={index} styleName="menu-items-list">
                  <a href={item.completeUrl}>{item.title}</a>
                </li>
              );
            })}
          </ul>

          <div styleName="social-links">
            <p>Connect with us</p>
            <SocialIcons socialLinks={props.socialLinks} />
            <SocialIcons showPodcast showTelegram showLinkedin showSpotify />
            <SocialIcons showCastBox />
          </div>
          <div styleName="about">
            <p>
              With your support, <br />
              we can do more ground-reports.
            </p>
            <a styleName="nl-btn" href="/sena">
              Join NL Sena
            </a>
          </div>
          <div styleName="copyright">
            <p styleName="copyright-text">© Newslaundry Media Private Limited. All Rights Reserved.</p>
            <a href="https://www.quintype.com">
              <p styleName="copyright-text">Powered by Quintype</p>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

FooterBase.propTypes = {
  menu: PT.arrayOf(
    PT.shape({
      completeUrl: PT.string,
      title: PT.string
    })
  ),
  socialLinks: PT.object
};

function mapStateToProps(state) {
  const domainslug = get(state, ["qt", "domainSlug"], "");
  const menu =
    domainslug === "newslaundry-hindi"
      ? get(state, ["qt", "data", "navigationMenu", "hindiFooterLinks"], undefined) ||
        get(state, ["qt", "data", "navigationMenu", "default"], [])
      : get(state, ["qt", "data", "navigationMenu", "footerLinks"], undefined) ||
        get(state, ["qt", "data", "navigationMenu", "default"], []);
  return {
    menu: menu,
    socialLinks: get(state, ["qt", "config", "social-links"], [])
  };
}

export const Footer = connect(mapStateToProps)(FooterBase);
